import type { BannerConfig, MenuContents } from './types';

export const menuContent: MenuContents = {
  KPlus: {
    left: [
      {
        blocks: [
          {
            title: 'Решения',
            blocks: [
              {
                label: 'Бухгалтеру',
                link: '/consultant-plus/buhgalteru',
              },
              {
                label: 'Юристу',
                link: '/consultant-plus/uristu',
              },
              {
                label: 'Руководителю',
                link: '/consultant-plus/rukovoditelu',
              },
              {
                label: 'Специалисту по закупкам',
                link: '/consultant-plus/specialist-po-zakupkam',
              },
              {
                label: 'Кадровому специалисту',
                link: '/consultant-plus/kadroviku',
              },
            ],
            footerButton: {
              label: 'Посмотреть все решения',
              link: '/consultant-plus',
            },
          },
        ],
      },
      {
        blocks: [
          {
            title: 'Сервисы',
            blocks: [
              {
                label: 'Информер',
                link: '/consultant-plus/service/informer',
              },
              {
                label: 'Экспресс ответ',
                link: '/consultant-plus/service/ekspress-otvet',

              },
              {
                label: 'Авторские семинары',
                link: '/consultant-plus/service/avtorskie-seminary',
              },
              {
                label: 'Письменные консультации',
                link: '/consultant-plus/service/pismennye-konsultacii',
              },
              {
                label: 'Индивидуальные семинары',
                link: '/consultant-plus/service/individualnye-seminary',
              },
            ],
            footerButton: {
              label: 'Посмотреть все cервисы',
              link: '/consultant-plus/service',
            },
          },
        ],
      },
    ],
    right: [
      {
        blocks: [
          {
            title: 'Продукты',
            blocks: [
              /* {
                label: 'Смарт-комплекты',
                link: '',
              }, */
              {
                label: 'Конструктор договоров',
                link: 'https://www.4dk.ru/consultant-plus/konstructor-dogovorov',
              },
              {
                label: 'Конструктор учетной политики',
                link: 'https://www.4dk.ru/consultant-plus/kup',
              },
              {
                label: 'Путеводители',
                link: 'https://www.4dk.ru/consultant-plus/putevoditeli',
              },
              {
                label: 'Готовые решения',
                link: 'https://www.4dk.ru/solutions',
              },
            ],
          },
          {
            title: 'Полезное',
            blocks: [
              {
                label: 'Практикумы',
                link: '/consultant-plus/praktikumy',
              },
              /* {
                label: 'Что нового ',
                link: '',
              }, */
            ],
          },
          {
            title: 'Другое',
            blocks: [
              {
                label: 'Купить Консультант Плюс',
                link: '/consultant-plus/prices',
              },
              {
                label: 'Пробный доступ',
                link: '/consultant-plus/big-test-drive',
              },
              {
                label: 'Скачать',
                link: 'https://www.4dk.ru/consultant-plus/download',
              },
            ],
          },
        ],
      },
    ],
  },
  SeminarsAndCourses: {
    left: [
      {
        blocks: [
          {
            title: 'Мероприятия и обучение',
            blocks: [
              {
                label: 'Расписание мероприятий',
                link: 'https://www.4dk.ru/seminars',
              },
              {
                label: 'Пакет вебинаров',
                link: 'https://www.4dk.ru/seminars/paket-vebinarov',
              },
              {
                label: 'Бесплатный тест-драйв курсов',
                link: 'https://www.4dk.ru/seminars/cpk-test-drive',
              },
              {
                label: 'Учебный абонемент',
                link: 'https://www.4dk.ru/seminars/abonement',
              },
              {
                label: 'Бонусы за обучение',
                link: 'http://4dko.tilda.ws/giftmagazin',
              },
              {
                label: 'Корпоративное обучение',
                link: 'https://www.4dk.ru/seminars/korporativnoe-obuchenie',
              },
            ],
          },
        ],
      },
      {
        blocks: [
          {
            title: 'О нас',
            blocks: [
              {
                label: 'О центре',
                link: 'https://www.4dk.ru/seminars/about-center',
              },
              {
                label: 'Преподавательский состав',
                link: 'https://www.4dk.ru/seminars/l',

              },
              {
                label: 'Реестр выпускников',
                link: 'https://www.4dk.ru/seminars/tranings-register',
              },
              {
                label: 'Сведения',
                link: 'https://www.4dk.ru/seminars/svedeniya',
              },
              {
                label: 'Блог',
                link: 'https://www.4dk.ru/content/streams/chto-delat-kvalifikatsiya',
              },
            ],
          },
        ],
      },
    ],
    right: [
      {
        blocks: [
          {
            title: 'Бонусы и рассылка',
            blocks: [
              {
                label: 'Подарки за рекомендацию',
                link: 'https://www.4dk.ru/seminars/recommendations',
              },
              {
                label: 'Подписаться на рассылку',
                link: 'https://www.4dk.ru/seminars/subscribe',
              },
            ],
          },
        ],
      },
    ],
  },
  About: {
    left: [
      {
        blocks: [
          {
            title: 'О компании',
            blocks: [
              {
                label: 'О нас',
                link: 'https://www.4dk.ru/s/about-us',
              },
              {
                label: 'Лицензии и сертификаты',
                link: 'https://www.4dk.ru/certificates-licenses',
              },
              {
                label: 'Контакты и реквизиты',
                link: 'https://www.4dk.ru/contacts',
              },
            ],
          },
        ],
      },
      {
        blocks: [
          {
            title: 'Карьера',
            blocks: [
              {
                label: 'Вакансии',
                link: 'https://www.4dk.ru/vacancies',
              },
            ],
          },
        ],
      },
    ],
    right: [],
  },
  Services: {
    left: [
      {
        blocks: [
          {
            title: 'Аудиторские услуги',
            label: 'Займитесь бизнесом, а мы поможем вам сэкономить для него время',
            link: 'http://4dk-audit.ru/',
          },
          {
            title: 'Регистрация предприятий',
            label: 'Создание, реорганизация, ликвидация всех возможных видов юр. лиц',
            link: 'https://4dk-reg.ru/',
          },
        ],
      },
    ],
    right: [],
  },
};

export const bannerConfig: BannerConfig = {
  default: [
    {
      img: '4dkmain/storage/0e68662a-c588-4bf7-b5eb-23bea67136e8.png',
      alt: 'Предоставим доступ к самой полной базе правовых документов бесплатно',
      link: '/consultant-plus/big-test-drive',
      buttonText: 'Предоставим доступ к самой полной базе правовых документов бесплатно',
    },
    {
      img: '4dkmain/storage/89cc0a8a-ad66-432a-bff7-dee6090a8728.png',
      alt: 'Информер',
      link: '/consultant-plus/service/informer',
      buttonText: 'Неделя профессиональной поддержки и обучения',
    },
  ],
  SeminarsAndCourses: [
    {
      img: '4dkmain/storage/cc7e65aa-c0e3-444c-9aec-945d8efaafee.png',
      alt: 'Пробный доступ к курсам',
      link: 'https://www.4dk.ru/seminars/cpk-test-drive',
      buttonText: 'Пробный доступ к курсам УЦ Что делать Квалификация',
    },
    {
      img: '4dkmain/storage/47330c66-b412-4892-ae0d-38a995560b4d.png',
      alt: 'Пройдите курс',
      link: 'https://www.4dk.ru/seminars/finansoviy-direktor',
      buttonText: 'Пройдите курс повышения квалификации и станьте востребованным специалистом',
    },
  ],
};
